import { useTranslations } from "next-intl";
import { montserrat } from "utils";

export function NoPaymentPopoverContent() {
  const t = useTranslations();

  const optionClassName = "flex flex-row items-center gap-2";
  return (
    <div className="p-2 rounded-xl max-w-[32rem]">
      <p>{t("Pricing.popover.noPaymentTopDescription")}</p>
      <ul>
        <li className={optionClassName}>
          <span className="text-base">⚠️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.noPaymentOptionFirst")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">⚠️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.noPaymentOptionSecond")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">⚠️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.noPaymentOptionThird")}
          </span>
        </li>
      </ul>
      <p>{t("Pricing.popover.noPaymentBottomDescription")}</p>
    </div>
  );
}
